import * as GroupType from 'constants/GroupType'
import * as Period from 'constants/Period'

const MARTIAL_ART_SCORE_MAP = {}
const defaultItem = {
  [GroupType.DEFAULT_GROUP]: {
    period_info: true,
  },
}
MARTIAL_ART_SCORE_MAP[Period.NOT_STARTED] = defaultItem
MARTIAL_ART_SCORE_MAP[Period.FIRST] = defaultItem
MARTIAL_ART_SCORE_MAP[Period.SECOND] = defaultItem
MARTIAL_ART_SCORE_MAP[Period.THIRD] = defaultItem
MARTIAL_ART_SCORE_MAP[Period.FOURTH] = defaultItem
MARTIAL_ART_SCORE_MAP[Period.FIFTH] = defaultItem
MARTIAL_ART_SCORE_MAP[Period.FINISHED] = defaultItem

export default MARTIAL_ART_SCORE_MAP



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/MartialArt/ScoreMap.js